import { render, staticRenderFns } from "./botton.vue?vue&type=template&id=7dd2e3e5&scoped=true&"
import script from "./botton.vue?vue&type=script&lang=js&"
export * from "./botton.vue?vue&type=script&lang=js&"
import style0 from "./botton.vue?vue&type=style&index=0&id=7dd2e3e5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd2e3e5",
  null
  
)

export default component.exports